import { fgWmsFilterEntries } from "@redotech/redo-fulfillment-operations-common/views/fulfillment/fg-filter-catalog";
import BoxIcon from "@redotech/redo-icons/box-01.svg";
import { NumberFilterOperator } from "@redotech/redo-views-common/advanced-filters/number-filter";
import { AdvancedTableFilter } from "@redotech/redo-web/advanced-filters/advanced-filter";

const entry = fgWmsFilterEntries.pickableBinCount;

export const PickableBinCountFilter: AdvancedTableFilter = {
  type: entry.type,
  Icon: BoxIcon,
  min: 0,
  data: {
    name: entry.name,
    type: entry.type,
    value: null,
    operator: NumberFilterOperator.LESS_THAN,
  },
  displayName: entry.displayName,
};
